import PolicyPage from "./PolicyPage";

export default function PrivacyPolicy() {
  return (
    <PolicyPage
      slug="privacy"
      title="Privacy Policy"
      intro="This policy explains how Fire Safety Systems handles personal information submitted through this website."
      sections={[
        {
          h: "Information we collect",
          p: [
            "When you submit an enquiry via the contact form we collect your name, company (if provided), email address, telephone number (if provided), site location (if provided), the service you are enquiring about, your message, and the date and time of submission.",
          ],
        },
        {
          h: "How we use it",
          p: [
            "We use this information solely to respond to your enquiry and to arrange any follow-up communications relating to fire safety services. We do not sell or rent your personal data to third parties.",
          ],
        },
        {
          h: "How long we keep it",
          p: [
            "We retain enquiry information only for as long as reasonably necessary to respond to your enquiry and to maintain records related to any subsequent work carried out.",
          ],
        },
        {
          h: "Your rights",
          p: [
            "You may request access to, correction of, or deletion of personal data we hold about you at any time by contacting us on service@fssl.ie.",
          ],
        },
      ]}
    />
  );
}
